var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlide4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 628,
    viewBox: "0 0 1200 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 628,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 0H0V628H1200V0Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017 628C1066.7 580.6 1097.7 513.8 1097.7 439.7C1097.7 296.1 981.3 179.6 837.6 179.6C837.3 179.6 837.1 179.6 836.8 179.6C796.5 105 717.5 54.3999 626.7 54.3999C528.2 54.3999 443.6 114 407 199.1C403.4 198.6 399.6 198.3 395.8 198.3C358.5 198.3 327.6 225.7 322.1 261.5C196.5 287.8 102.2 399.2 102.2 532.6C102.2 566.2 108.2 598.3 119.1 628.1H1017V628Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.7 380.7H215.8V544.6H236.7V380.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.3 422H226.3V544.7H311.3V422Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.7 422H926V544.7H1048.7V422Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.3 315.6H300.1V544.7H357.3V315.6Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.8 276.4H830.6V544.7H887.8V276.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.9 310.6H904.7V544.7H961.9V310.6Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.9 106.7H496.7V544.6H553.9V106.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.1 142.2H731.7V544.7H779.1V142.2Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.4 123.3H741V544.7H755.4V123.3Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926 166.2H869.8V544.6H926V166.2Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942 247.9H897.8V544.7H942V247.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.9 148.5H875.3V544.7H883.9V148.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 544.7H578.7V127.9L636 168.8V544.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.5 86.3H607.3V544.7H664.5V86.3Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.5 159.3H542.8V544.7H583.5V159.3Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.3 91.6H501.9V529.5H533.3V91.6Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.3 239.3H421.1V544.7H478.3V239.3Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.3 544.7H468.1V215.3L525.3 231.3V544.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 544.7H689.8V215.3L747 231.3V544.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.3 544.7H388.1V171.8L426 148.5L445.3 171.8V544.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.3 544.7H652.1V171.8L690 148.5L709.3 171.8V544.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.3 544.7H759.1V224.2L791.5 159.3L816.3 224.2V544.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.7 544.7H339.4V315.6L396.7 292.3V544.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.3 544.7H265.5V226.4L311.3 263.5V544.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017 544.7H979.2V281.7L1017 312.3V544.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.7 544.7H853.5V226.4L807.7 263.5V544.7Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.3 83.8001C110.4 83.8001 83.5001 105.2 75.1001 134.4H209.4C201.1 105.2 174.2 83.8001 142.3 83.8001Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.6 83.8001C293.7 83.8001 266.8 105.2 258.4 134.4H392.7C384.4 105.2 357.5 83.8001 325.6 83.8001Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.2 62.1001C192.6 62.1001 154.2 92.7001 142.2 134.4H334.1C322.3 92.7001 283.8 62.1001 238.2 62.1001Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.2 248.9C1021.2 248.9 1013.5 255 1011.2 263.3H1049.3C1046.8 254.9 1039.2 248.9 1030.2 248.9Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.1 248.9C1073.1 248.9 1065.4 255 1063.1 263.3H1101.2C1098.8 254.9 1091.1 248.9 1082.1 248.9Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.3 242.7C1044.4 242.7 1033.5 251.4 1030.1 263.2H1084.5C1081.2 251.4 1070.3 242.7 1057.3 242.7Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.7 391.8C800.7 396.3 800.7 400.8 800.6 405.3C800.6 407.3 800.5 409.4 800.5 411.4C800.5 414 800.4 416.5 800.3 419.1C800.3 420.9 800.2 422.6 800.2 424.4C799.6 441.2 798.6 457.6 797.3 473.4C797 477.3 796.6 481.1 796.2 484.9C796.1 486.2 795.9 487.5 795.8 488.8C794.5 501.1 793 513.1 791.2 524.6H622.5C622.4 523.9 622.3 523.1 622.2 522.4C620.1 508.6 618.4 494.3 617 479.4C616.9 478.6 616.8 477.8 616.8 476.9C616.5 473.8 616.2 470.6 616 467.4C614.8 453.1 614 438.4 613.5 423.3C613.5 422.5 613.5 421.6 613.4 420.8C613.3 416.5 613.2 412.1 613.1 407.8C613 402.5 613 397.1 613 391.7C613 381.5 613.2 371.3 613.5 361.1C613.5 359.8 613.6 358.4 613.6 357.1C613.7 354.2 613.8 351.2 613.9 348.3C614 346.5 614.1 344.7 614.1 342.9C614.9 325.1 616.2 307.4 617.9 290.1C618 289.1 618.1 288.2 618.2 287.2C618.7 281.9 619.3 276.6 619.9 271.4C620.8 263.4 621.8 255.6 622.9 247.9C624.8 234.3 627 221.1 629.4 208.3C630.3 203.6 631.2 199 632.1 194.4C632.4 192.8 632.7 191.3 633.1 189.8C633.5 187.9 633.9 185.9 634.4 184C637.9 168.2 641.8 153.5 645.9 139.9C649.6 127.9 653.5 116.8 657.7 106.9C657.7 106.8 657.8 106.7 657.8 106.6H755.6C759.2 115.2 762.7 124.7 765.9 134.9C766.9 138 767.9 141.1 768.8 144.3C772.2 155.9 775.4 168.2 778.4 181.3C779.2 184.7 779.9 188.1 780.7 191.6C781.3 194.6 782 197.7 782.6 200.8C783.8 206.7 784.9 212.7 786 218.8C786.7 223 787.5 227.2 788.1 231.6C788.7 235.3 789.3 239 789.8 242.7C791.9 256.6 793.6 270.9 795.1 285.5C795.5 289.2 795.8 292.8 796.2 296.5C796.2 296.8 796.2 297.1 796.3 297.3C797.7 312.4 798.7 327.7 799.5 343.1C799.6 345.6 799.7 348 799.8 350.5C799.9 352.3 799.9 354 800 355.8C800.5 367.9 800.7 379.9 800.7 391.8Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.5 411.5C800.4 415.8 800.3 420.2 800.2 424.5L632.2 194.5C632.9 191 633.7 187.5 634.4 184.1L800.5 411.5Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.1 219L704.1 106.7L677.8 70.6C679.5 68.3 681.3 66.3 683.1 64.4L714 106.7L782.8 200.9C783.9 206.9 785 212.9 786.1 219Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.8 106.7L629.5 208.4C630.4 203.7 631.3 199.1 632.2 194.5C632.5 192.9 632.8 191.4 633.2 189.9L694 106.7H703.8Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.2 106.7L618.3 287.3C618.8 282 619.4 276.7 620 271.5L740.4 106.7H750.2Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769 144.4L613.6 357.2C613.7 354.3 613.8 351.3 613.9 348.4C614 346.6 614.1 344.8 614.1 343L766 135C767.1 138.1 768 141.2 769 144.4Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.8 191.7L613.4 421C613.3 416.7 613.2 412.3 613.1 408L778.6 181.4C779.4 184.8 780.1 188.3 780.8 191.7Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.9 242.8L617 479.6C616.9 478.8 616.8 478 616.8 477.1C616.5 474 616.2 470.8 616 467.6L788.2 231.8C788.8 235.4 789.4 239.1 789.9 242.8Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.4 297.5L630.4 524.7H622.5C622.4 524 622.3 523.2 622.2 522.5L795.2 285.6C795.6 289.3 795.9 292.9 796.3 296.6C796.3 297 796.3 297.2 796.4 297.5Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 356L676.8 524.7H667L799.5 343.2C799.6 345.7 799.7 348.1 799.8 350.6C799.9 352.4 800 354.2 800 356Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.6 405.3C800.6 407.3 800.5 409.4 800.5 411.4C800.5 414 800.4 416.5 800.3 419.1L723.2 524.7H713.4L800.6 405.3Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.2 473.5C796.9 477.4 796.5 481.2 796.1 485C796 486.3 795.8 487.6 795.7 488.9L769.5 524.7H759.7L797.2 473.5Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.7 524.7H732.9L613.4 361.3C613.5 357 613.7 352.8 613.9 348.5L742.7 524.7Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.8 350.7L646 140C649.7 128 653.6 116.9 657.8 107L796.3 296.6C797.9 314.4 799.1 332.5 799.8 350.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.1 485C794.7 498.7 793 512 791.1 524.8H789.3L618 290.2C619.4 275.8 621.1 261.7 623 248L796.1 485Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.5 524.7H651.6L616.8 477.1C615.2 459.8 614.1 441.9 613.5 423.5L687.5 524.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.7 106.7H657.9C664.1 92 670.7 79.8 677.7 70.6C679.4 68.3 681.2 66.3 683 64.4C690.6 56.4 698.6 52 706.8 52C724.7 52 741.5 72.7 755.7 106.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 165.2C708 165.2 700.3 171.3 698 179.6H736.1C733.7 171.3 726 165.2 717 165.2Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.9 165.2C759.9 165.2 752.2 171.3 749.9 179.6H788C785.6 171.3 778 165.2 768.9 165.2Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.2 159.1C731.3 159.1 720.4 167.8 717 179.6H771.4C768 167.7 757.1 159.1 744.2 159.1Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6 340.6C189.9 340.6 181.7 347.1 179.2 356H220.1C217.5 347.1 209.3 340.6 199.6 340.6Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4 340.6C245.7 340.6 237.5 347.1 235 356H275.9C273.3 347.1 265.1 340.6 255.4 340.6Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8 334C214.9 334 203.2 343.3 199.6 356H258C254.4 343.3 242.7 334 228.8 334Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9 122.9C137.3 122.9 120.8 136 115.7 154H198.1C193 136 176.5 122.9 156.9 122.9Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3 122.9C249.7 122.9 233.2 136 228.1 154H310.5C305.4 136 288.9 122.9 269.3 122.9Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.7 109.6C187.7 109.6 164.2 128.4 156.8 154H274.5C267.3 128.3 243.7 109.6 215.7 109.6Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.1 199.4H342.2V522.3H443.1V199.4Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.1 189.1H352.2V522.3H433.1V189.1Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.3 180H360V522.3H425.3V180Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.8 482.4H374.5V152.2L382.4 140.1H402.9L410.8 151.9V482.4Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.4 236.8V393.7H365.8V236.8H329.8V524.7H455.5V236.8H419.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.6 442.2H426V524.7H470.6V442.2Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.9 472H463.1V524.7H479.9V472Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.798 524.684H353.398V442.184H308.798V524.684Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.5 472H299.7V524.7H316.5V472Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.2 129.2H385V144.4H400.2V129.2Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.4 100.2H390.8V135.6H394.4V100.2Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.2 72.8H392V108.2H393.2V72.8Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.3 206.2H363.7V215.8H370.3V206.2Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 206.2H376.5V215.8H383.1V206.2Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 206.2H389.3V215.8H395.9V206.2Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 206.2H402.2V215.8H408.8V206.2Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.6 206.2H415V215.8H421.6V206.2Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.3 221.6H363.7V231.2H370.3V221.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 221.6H376.5V231.2H383.1V221.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 221.6H389.3V231.2H395.9V221.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 221.6H402.2V231.2H408.8V221.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.6 221.6H415V231.2H421.6V221.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 236.8H376.5V246.4H383.1V236.8Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 236.8H389.3V246.4H395.9V236.8Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 236.8H402.2V246.4H408.8V236.8Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 251.7H376.5V261.3H383.1V251.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 251.7H389.3V261.3H395.9V251.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 251.7H402.2V261.3H408.8V251.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 266.7H376.5V276.3H383.1V266.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 266.7H389.3V276.3H395.9V266.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 266.7H402.2V276.3H408.8V266.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 281.6H376.5V291.2H383.1V281.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 281.6H389.3V291.2H395.9V281.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 281.6H402.2V291.2H408.8V281.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 296.6H376.5V306.2H383.1V296.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 296.6H389.3V306.2H395.9V296.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 296.6H402.2V306.2H408.8V296.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 311.5H376.5V321.1H383.1V311.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 311.5H389.3V321.1H395.9V311.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 311.5H402.2V321.1H408.8V311.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 326.5H376.5V336.1H383.1V326.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 326.5H389.3V336.1H395.9V326.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 326.5H402.2V336.1H408.8V326.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 341.5H376.5V351.1H383.1V341.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 341.5H389.3V351.1H395.9V341.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 341.5H402.2V351.1H408.8V341.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 356.4H376.5V366H383.1V356.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 356.4H389.3V366H395.9V356.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 356.4H402.2V366H408.8V356.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1 371.4H376.5V381H383.1V371.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.9 371.4H389.3V381H395.9V371.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8 371.4H402.2V381H408.8V371.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.2 191.8H376.6V201.4H383.2V191.8Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 191.8H389.4V201.4H396V191.8Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.9 191.8H402.3V201.4H408.9V191.8Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.4 247.8H427V261.3H434.4V247.8Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.8 247.8H441.4V261.3H448.8V247.8Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.4 270.4H427V283.9H434.4V270.4Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.8 270.4H441.4V283.9H448.8V270.4Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.4 292.9H427V306.4H434.4V292.9Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.8 292.9H441.4V306.4H448.8V292.9Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.4 315.5H427V329H434.4V315.5Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.8 315.5H441.4V329H448.8V315.5Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.4 338H427V351.5H434.4V338Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.8 338H441.4V351.5H448.8V338Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8 247.8H336.4V261.3H343.8V247.8Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2 247.8H350.8V261.3H358.2V247.8Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8 270.4H336.4V283.9H343.8V270.4Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2 270.4H350.8V283.9H358.2V270.4Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8 292.9H336.4V306.4H343.8V292.9Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2 292.9H350.8V306.4H358.2V292.9Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8 315.5H336.4V329H343.8V315.5Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2 315.5H350.8V329H358.2V315.5Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8 338H336.4V351.5H343.8V338Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2 338H350.8V351.5H358.2V338Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.9 89.4001C884.9 89.4001 867.2 103.5 861.7 122.7H950.1C944.7 103.4 927 89.4001 905.9 89.4001Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.6 89.4001C1005.6 89.4001 987.9 103.5 982.4 122.7H1070.8C1065.3 103.4 1047.6 89.4001 1026.6 89.4001Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.1 75.1001C939.1 75.1001 913.8 95.2001 906 122.7H1032.3C1024.4 95.2001 999.1 75.1001 969.1 75.1001Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.1 130.4H522.1L524.3 115.2H551.8L554.1 130.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.6 161.9H499.5L505.1 125.4H571.1L576.6 161.9Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.5 142.4H492.6V524.7H583.5V142.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.5 433.8H492.6V524.7H583.5V433.8Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.5 435.3H492.6L495.7 417.3L497.4 407.6L499.5 394.7L501.2 385L503.4 372.2L505 362.5L507.2 349.6L508.9 339.9L511.1 327.1L512.7 317.4L514.9 304.5L516.6 294.8L518.8 282L520.4 272.3L522.6 259.4L524.2 249.7L526.4 236.9L528.1 227.2L530.3 214.3L531.9 204.6L534.1 191.8L535.8 182.1L538.1 168.6L540.3 182.1L542 191.8L544.2 204.6L545.8 214.3L548 227.2L549.7 236.9L551.9 249.7L553.5 259.4L555.7 272.3L557.4 282L559.6 294.8L561.2 304.5L563.4 317.4L565.1 327.1L567.2 339.9L568.9 349.6L571.1 362.5L572.7 372.2L574.9 385L576.6 394.7L578.8 407.6L580.4 417.3L583.5 435.3Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.4 417.3H495.7L497.4 407.6H578.8L580.4 417.3Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.6 394.7H499.5L501.2 385H574.9L576.6 394.7Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.7 372.2H503.4L505 362.5H571.1L572.7 372.2Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.9 349.6H507.2L508.9 339.9H567.2L568.9 349.6Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.8 97.8H535.4V123.5H540.8V97.8Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.1 327.1H511.1L512.7 317.4H563.4L565.1 327.1Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.2 304.5H514.9L516.6 294.8H559.6L561.2 304.5Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.4 282H518.8L520.4 272.3H555.7L557.4 282Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.5 259.4H522.6L524.2 249.7H551.9L553.5 259.4Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.7 236.9H526.4L528.1 227.2H548L549.7 236.9Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.8 214.3H530.3L531.9 204.6H544.2L545.8 214.3Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 191.8H534.1L535.8 182.1H540.3L542 191.8Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.4 445.6H502.5V516.3H512.4V445.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.8 445.6H522.9V516.3H532.8V445.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.2 445.6H543.3V516.3H553.2V445.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.6 445.6H563.7V516.3H573.6V445.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.327 123.508H538.727V51.3076H537.327V123.508Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4 530.9C193.4 520.3 184.8 511.7 174.2 511.7C163.6 511.7 155 520.3 155 530.9C155 536.3 157.2 541.2 160.8 544.6H187.6C191.2 541.2 193.4 536.3 193.4 530.9Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.7 125.2H857.7V399.3H902.7V125.2Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.7 198.2H838.7V525.3H921.7V198.2Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.3 81.5H875.1V107.5H885.3V81.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.9 65.3H877.5V91.3H882.9V65.3Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.2 50H879.2V76H881.2V50Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.3 205.8H830L857.7 149.1H902.7L930.3 205.8Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.2 127H855.1L875.1 98.7H885.2L905.2 127Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.3 222.9H830V305.9H930.3V222.9Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.3 330.6H830V524.2H930.3V330.6Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.2 295.5C897.376 295.5 911.3 281.576 911.3 264.4C911.3 247.224 897.376 233.3 880.2 233.3C863.024 233.3 849.1 247.224 849.1 264.4C849.1 281.576 863.024 295.5 880.2 295.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.702 280.769C906.768 271.1 906.279 255.912 896.61 246.845C886.941 237.779 871.752 238.268 862.686 247.937C853.62 257.607 854.109 272.795 863.778 281.861C873.447 290.928 888.636 290.439 897.702 280.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.2 245.2V249.3",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.2 280.7V284.7",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.9 265H895.8",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.5 265H860.4",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.4 264.4C878.4 263.4 879.2 262.7 880.1 262.7C881 262.7 881.8 263.5 881.8 264.4C881.8 265.3 881 266.1 880.1 266.1C879.2 266.1 878.4 265.3 878.4 264.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 273.8L880.2 264.4",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.3 248.5L880.2 264.4",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.4 395.5C840.7 395.5 839.3 394.1 839.3 392.4V345.5C839.3 343.8 840.7 342.4 842.4 342.4C844.1 342.4 845.5 343.8 845.5 345.5V392.4C845.6 394.1 844.2 395.5 842.4 395.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855 395.5C853.3 395.5 851.9 394.1 851.9 392.4V345.5C851.9 343.8 853.3 342.4 855 342.4C856.7 342.4 858.1 343.8 858.1 345.5V392.4C858.1 394.1 856.7 395.5 855 395.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.6 395.5C865.9 395.5 864.5 394.1 864.5 392.4V345.5C864.5 343.8 865.9 342.4 867.6 342.4C869.3 342.4 870.7 343.8 870.7 345.5V392.4C870.7 394.1 869.3 395.5 867.6 395.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.2 395.5C878.5 395.5 877.1 394.1 877.1 392.4V345.5C877.1 343.8 878.5 342.4 880.2 342.4C881.9 342.4 883.3 343.8 883.3 345.5V392.4C883.3 394.1 881.9 395.5 880.2 395.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.7 395.5C891 395.5 889.6 394.1 889.6 392.4V345.5C889.6 343.8 891 342.4 892.7 342.4C894.4 342.4 895.8 343.8 895.8 345.5V392.4C895.9 394.1 894.5 395.5 892.7 395.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.3 395.5C903.6 395.5 902.2 394.1 902.2 392.4V345.5C902.2 343.8 903.6 342.4 905.3 342.4C907 342.4 908.4 343.8 908.4 345.5V392.4C908.4 394.1 907 395.5 905.3 395.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.9 395.5C916.2 395.5 914.8 394.1 914.8 392.4V345.5C914.8 343.8 916.2 342.4 917.9 342.4C919.6 342.4 921 343.8 921 345.5V392.4C921 394.1 919.6 395.5 917.9 395.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.4 462.3C840.7 462.3 839.3 460.9 839.3 459.2V412.3C839.3 410.6 840.7 409.2 842.4 409.2C844.1 409.2 845.5 410.6 845.5 412.3V459.2C845.6 460.9 844.2 462.3 842.4 462.3Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855 462.3C853.3 462.3 851.9 460.9 851.9 459.2V412.3C851.9 410.6 853.3 409.2 855 409.2C856.7 409.2 858.1 410.6 858.1 412.3V459.2C858.1 460.9 856.7 462.3 855 462.3Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.6 462.3C865.9 462.3 864.5 460.9 864.5 459.2V412.3C864.5 410.6 865.9 409.2 867.6 409.2C869.3 409.2 870.7 410.6 870.7 412.3V459.2C870.7 460.9 869.3 462.3 867.6 462.3Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.2 462.3C878.5 462.3 877.1 460.9 877.1 459.2V412.3C877.1 410.6 878.5 409.2 880.2 409.2C881.9 409.2 883.3 410.6 883.3 412.3V459.2C883.3 460.9 881.9 462.3 880.2 462.3Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.7 462.3C891 462.3 889.6 460.9 889.6 459.2V412.3C889.6 410.6 891 409.2 892.7 409.2C894.4 409.2 895.8 410.6 895.8 412.3V459.2C895.9 460.9 894.5 462.3 892.7 462.3Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.3 462.3C903.6 462.3 902.2 460.9 902.2 459.2V412.3C902.2 410.6 903.6 409.2 905.3 409.2C907 409.2 908.4 410.6 908.4 412.3V459.2C908.4 460.9 907 462.3 905.3 462.3Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.9 462.3C916.2 462.3 914.8 460.9 914.8 459.2V412.3C914.8 410.6 916.2 409.2 917.9 409.2C919.6 409.2 921 410.6 921 412.3V459.2C921 460.9 919.6 462.3 917.9 462.3Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.4 561.4H320.6C310.3 561.4 301.9 553 301.9 542.7C301.9 532.4 310.3 524 320.6 524H879.3C889.6 524 898 532.4 898 542.7C898.1 553 889.7 561.4 879.4 561.4Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.8 528.3C223.8 515.7 213.6 505.4 200.9 505.4C188.3 505.4 178 515.6 178 528.3C178 534.7 180.7 540.5 184.9 544.7H216.8C221.1 540.5 223.8 534.7 223.8 528.3Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.3 525.2C327.3 510.2 315.1 498 300.1 498C285.1 498 272.9 510.2 272.9 525.2C272.9 532.8 276.1 539.8 281.1 544.7H319.1C324.2 539.7 327.3 532.8 327.3 525.2Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.8 511.9C292.8 486.6 272.3 466.1 247 466.1C221.7 466.1 201.2 486.6 201.2 511.9C201.2 524.8 206.5 536.4 215 544.7H278.8C287.4 536.4 292.8 524.8 292.8 511.9Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.2 229.5C409.8 229.5 401 236.5 398.3 246H442.1C439.4 236.4 430.6 229.5 420.2 229.5Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 229.5C469.6 229.5 460.8 236.5 458.1 246H501.9C499.2 236.4 490.4 229.5 480 229.5Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.5 222.4C436.6 222.4 424.1 232.4 420.2 246H482.8C478.9 232.4 466.4 222.4 451.5 222.4Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.5 528.3C1063.5 515.7 1053.3 505.4 1040.6 505.4C1027.9 505.4 1017.7 515.6 1017.7 528.3C1017.7 534.7 1020.4 540.5 1024.6 544.7H1056.5C1060.9 540.5 1063.5 534.7 1063.5 528.3Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.3 513.6C969.3 489.7 949.9 470.3 926 470.3C902.1 470.3 882.7 489.7 882.7 513.6C882.7 525.8 887.7 536.8 895.8 544.6H956.2C964.3 536.8 969.3 525.8 969.3 513.6Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.8 525.2C993.8 510.2 981.6 498 966.6 498C951.6 498 939.4 510.2 939.4 525.2C939.4 532.8 942.6 539.8 947.6 544.7H985.6C990.7 539.7 993.8 532.8 993.8 525.2Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.8 269.2C710 269.2 700.8 276.5 698 286.4H743.6C740.8 276.4 731.7 269.2 720.8 269.2Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783 269.2C772.2 269.2 763 276.5 760.2 286.4H805.8C803 276.4 793.9 269.2 783 269.2Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.4 261.8C737.9 261.8 724.9 272.2 720.8 286.3H786C781.9 272.2 768.9 261.8 753.4 261.8Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.3 313.9C613.1 313.3 617 309.5 617.6 304.6C617.6 304.5 617.7 304.5 617.7 304.6C618.3 309.4 622.1 313.3 627 313.9C627.1 313.9 627.1 314 627 314C622.2 314.6 618.3 318.4 617.7 323.3C617.7 323.4 617.6 323.4 617.6 323.3C617 318.5 613.2 314.6 608.3 314C608.2 314.1 608.2 313.9 608.3 313.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.3 313.9C826.1 313.3 830 309.5 830.6 304.6C830.6 304.5 830.7 304.5 830.7 304.6C831.3 309.4 835.1 313.3 840 313.9C840.1 313.9 840.1 314 840 314C835.2 314.6 831.3 318.4 830.7 323.3C830.7 323.4 830.6 323.4 830.6 323.3C830 318.5 826.2 314.6 821.3 314C821.2 314.1 821.2 313.9 821.3 313.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6 421.9C297.4 421.3 301.3 417.5 301.9 412.6C301.9 412.5 302 412.5 302 412.6C302.6 417.4 306.4 421.3 311.3 421.9C311.4 421.9 311.4 422 311.3 422C306.5 422.6 302.6 426.4 302 431.3C302 431.4 301.9 431.4 301.9 431.3C301.3 426.5 297.5 422.6 292.6 422C292.5 422 292.5 421.9 292.6 421.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.9 286.3C597.5 285.9 599.6 283.8 600 281.2C600 281.1 600.1 281.1 600.1 281.2C600.5 283.8 602.6 285.9 605.2 286.3C605.3 286.3 605.3 286.4 605.2 286.4C602.6 286.8 600.5 288.9 600.1 291.5C600.1 291.6 600 291.6 600 291.5C599.6 288.9 597.5 286.8 594.9 286.4C594.8 286.4 594.8 286.3 594.9 286.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.1 231.2C757.7 230.8 759.8 228.7 760.2 226.1C760.2 226 760.3 226 760.3 226.1C760.7 228.7 762.8 230.8 765.4 231.2C765.5 231.2 765.5 231.3 765.4 231.3C762.8 231.7 760.7 233.8 760.3 236.4C760.3 236.5 760.2 236.5 760.2 236.4C759.8 233.8 757.7 231.7 755.1 231.3C755 231.3 755 231.2 755.1 231.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 191.7C474.1 191.3 476.2 189.2 476.6 186.6C476.6 186.5 476.7 186.5 476.7 186.6C477.1 189.2 479.2 191.3 481.8 191.7C481.9 191.7 481.9 191.8 481.8 191.8C479.2 192.2 477.1 194.3 476.7 196.9C476.7 197 476.6 197 476.6 196.9C476.2 194.3 474.1 192.2 471.5 191.8C471.4 191.8 471.4 191.7 471.5 191.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.5 375.3C468.1 374.9 470.2 372.8 470.6 370.2C470.6 370.1 470.7 370.1 470.7 370.2C471.1 372.8 473.2 374.9 475.8 375.3C475.9 375.3 475.9 375.4 475.8 375.4C473.2 375.8 471.1 377.9 470.7 380.5C470.7 380.6 470.6 380.6 470.6 380.5C470.2 377.9 468.1 375.8 465.5 375.4C465.4 375.4 465.4 375.3 465.5 375.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.2 333.9C813.8 333.5 815.9 331.4 816.3 328.8C816.3 328.7 816.4 328.7 816.4 328.8C816.8 331.4 818.9 333.5 821.5 333.9C821.6 333.9 821.6 334 821.5 334C818.9 334.4 816.8 336.5 816.4 339.1C816.4 339.2 816.3 339.2 816.3 339.1C815.9 336.5 813.8 334.4 811.2 334C811.1 334 811.1 333.9 811.2 333.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.792 526.8C351.692 526.7 351.592 526.6 351.492 526.5C350.892 525.5 351.192 524.3 352.092 523.7L364.492 515.9C365.492 515.3 366.692 515.6 367.292 516.5C367.892 517.5 367.592 518.7 366.692 519.3L354.292 527.1C353.492 527.6 352.492 527.5 351.792 526.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.992 523.1C351.992 523.1 347.292 525.8 348.092 526.8C348.892 527.8 360.992 541.3 361.592 540.8C363.892 539.1 355.592 526.5 354.392 525.7C353.292 524.8 352.692 522.7 351.992 523.1Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.092 356.7C442.092 356.7 438.992 346.7 436.492 345.7C433.992 344.7 435.892 354.6 440.692 358.8L442.092 356.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.692 354.6C441.892 355.1 439.992 355.7 438.192 356.3C449.392 383.6 443.292 404.4 418.392 374.7C414.592 370.2 413.192 374.3 411.892 377C411.092 376.4 411.092 376.5 411.892 377C410.592 379.8 409.792 379.4 414.392 383.6C444.892 410.6 459.892 387.4 443.692 354.6Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.992 548C413.892 548 413.692 548 413.592 548C412.492 547.8 411.792 546.7 411.992 545.6L414.892 531.3C415.092 530.2 416.192 529.5 417.292 529.7C418.392 529.9 419.092 531 418.892 532.1L415.992 546.4C415.792 547.4 414.892 548 413.992 548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.492 539.7C416.292 539.6 414.192 539.4 411.992 539.1C418.492 504.6 423.292 458.3 406.092 426.1C411.292 423.5 416.592 421 421.892 418.5C434.492 446.6 423.692 510 418.492 539.7Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.792 525.3C359.392 523.5 357.992 521.8 356.692 519.9C395.992 493.5 409.492 468.6 401.292 420.4C407.192 419.4 413.092 418.6 418.992 417.7C417.592 474 404.192 492.4 360.792 525.3Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.392 545.3C411.392 545.3 410.092 550.5 411.392 550.7C412.692 550.8 430.792 551.4 430.892 550.6C431.292 547.7 416.392 545.1 414.992 545.4C413.592 545.6 411.592 544.6 411.392 545.3Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.592 430.2C423.192 429.1 416.092 430.9 412.692 430.2C407.692 429.2 405.192 429.6 400.192 429.8C399.592 414.2 400.092 397.8 398.992 382.5C398.792 379.3 398.592 377.4 399.192 374.9C399.992 371.7 401.692 369.4 403.892 368.2C406.592 366.7 409.992 366.8 413.492 368.6C413.992 368.8 414.492 369.1 414.992 369.5C417.092 371.1 418.992 374.2 419.292 380C419.892 394.7 423.792 415.2 426.592 430.2Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.892 369.7L414.592 379.5L414.192 391.8L409.092 380.4L403.692 368.4C406.392 366.9 409.792 367 413.292 368.8C413.892 369 414.392 369.3 414.892 369.7Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.492 358.9C407.892 364.1 414.192 365.9 417.292 363.9C420.492 361.8 419.292 356.7 415.892 351.5C412.492 346.3 408.292 345.4 405.092 347.4C401.992 349.5 401.192 353.7 404.492 358.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.392 362.2C404.192 363.4 406.392 364.2 407.192 363.6C408.092 363 407.692 361.9 406.892 360.7C406.092 359.5 404.692 358.8 403.792 359.4C402.892 360 402.592 361 403.392 362.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.292 358.1L411.692 357.5C411.792 358.4 412.492 366.8 412.092 369.9C411.892 370.9 410.292 371.3 408.492 370.9C406.892 370.5 405.792 369.6 405.792 368.7C405.992 366.7 405.592 361.1 405.292 358.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.692 360.7C408.592 359.7 409.492 360.6 411.792 361.9C414.092 363.2 418.192 362.9 418.492 357.5C418.692 354.1 420.592 359.7 420.592 359.7C420.992 362.5 420.192 364.2 418.392 365.4C415.792 367.1 411.692 366.8 407.992 364.7C407.392 363.2 406.992 361.4 407.692 360.7Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.592 357.3C418.592 357.3 418.492 357.3 418.392 357.4C417.292 358 412.192 360.9 411.692 363C411.092 365.4 414.392 362.1 415.392 360.6C416.392 359.1 417.592 359.3 418.692 359C419.792 358.6 420.292 357.2 418.592 357.3Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.592 356.1C401.592 356.1 400.492 352.1 402.292 349.2C404.092 346.3 409.192 343.3 413.292 347.2C413.292 347.2 415.892 350.2 411.992 353.1C408.092 356 407.592 353.3 406.692 356.5C405.792 359.7 403.092 359.2 402.992 359.9L401.592 356.1Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.592 379.5L414.192 391.7L409.092 380.3L409.292 372.9H411.592L414.592 379.5Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.292 353.1L432.592 357.7C431.592 358.7 429.892 358.7 428.892 357.6L417.992 346.4C416.992 345.4 416.992 343.7 418.092 342.7L422.792 338.1C423.792 337.1 425.492 337.1 426.492 338.2L437.392 349.5C438.392 350.5 438.392 352.1 437.292 353.1Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.144 338.145L418.109 344.969L430.016 357.243L437.05 350.419L425.144 338.145Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.592 454.3H360.992V483H398.592V454.3Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.792 456V447.8H385.892V457.3",
    stroke: "#1A1C2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.492 437C379.492 437 381.792 447.8 380.092 449.9C378.292 452.1 374.992 442 377.092 435.7L379.492 437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.792 438.3C379.092 438.1 377.492 437.9 375.792 437.7C380.092 409.6 381.192 401.2 396.992 377.5C399.392 373.9 400.392 374.2 403.292 376.6C403.892 376.2 403.892 376.3 403.292 376.6C406.092 379 405.692 379.9 402.992 383.5C385.492 407 388.392 410.8 380.792 438.3Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.189 537.663C725.343 537.443 726.498 537.223 727.598 537.003C722.319 510.666 715.392 482.625 715.831 455.683C713.907 455.463 711.928 455.298 710.003 455.133C709.453 482.405 718.141 511.161 724.189 537.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.038 534.584C728.038 534.584 728.917 538.818 727.928 538.928C726.938 539.038 712.312 539.038 712.257 538.323C712.037 536.013 724.024 534.254 725.178 534.474C726.333 534.749 727.928 533.979 728.038 534.584Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.78 535.794C689.879 536.178 690.979 536.618 692.079 536.948C701.811 508.247 700.986 481.305 708.684 453.374C706.869 452.604 705 451.889 703.185 451.229C695.323 478.061 696.917 507.312 688.78 535.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.518 534.584C692.518 534.584 693.398 538.818 692.408 538.928C691.419 539.038 676.793 539.038 676.738 538.323C676.518 536.013 688.505 534.254 689.659 534.474C690.814 534.694 692.408 533.979 692.518 534.584Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.708 436.285C686.708 436.285 679.881 441.284 679.81 443.383C679.7 445.522 686.724 441.495 688.692 436.784L686.708 436.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.851 435.744C686.671 436.868 687.413 437.993 688.233 439.041C705.296 425.611 711.376 418.088 706.679 396.292C705.969 392.95 704.608 393.071 702.201 394.168C701.85 393.663 701.85 393.663 702.201 394.168C699.794 395.264 699.837 396.314 700.507 399.228C704.845 418.264 699.183 422.793 685.851 435.744Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.268 480.15C723.584 480.59 720.505 481.58 717.646 483.834C717.481 483.944 717.316 484.109 717.151 484.274C716.216 485.099 715.557 485.924 714.622 486.803C714.072 487.298 713.577 487.738 713.027 488.178C711.378 489.553 709.563 490.872 707.749 492.027C706.319 492.962 704.835 493.896 703.24 494.501C702.525 494.776 701.866 494.996 701.151 495.216C699.391 495.656 697.577 495.876 695.763 495.931H695.708C695.927 488.563 696.037 482.02 696.202 476.192C696.257 474.542 696.312 472.948 696.422 471.463C696.917 462.391 698.017 454.913 700.986 448.205C701.646 446.776 702.361 445.346 703.185 443.971C703.68 443.147 704.175 442.377 704.725 441.552C707.089 438.143 710.113 434.899 714.072 431.655C715.941 430.666 716.051 431.545 716.656 431.325C717.041 431.71 717.536 431.985 717.921 432.37C719.075 433.58 719.955 434.679 720.56 435.834C721.825 438.308 721.935 440.782 721.495 443.916C721.33 445.181 721.055 446.556 720.78 448.095C720.725 448.26 720.725 448.37 720.67 448.535C719.185 456.068 718.91 460.851 719.79 465.03C720.065 466.24 720.395 467.394 720.835 468.549C722.1 472.013 724.244 475.422 727.268 480.15Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.89 368.644C706.484 368.534 708.409 369.634 708.958 371.229C709.508 372.823 708.299 374.473 706.814 374.967C705.33 375.462 702.25 373.868 701.701 372.328C701.151 370.734 702.91 368.754 704.89 368.644Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.223 366.555C713.137 364.246 718.306 363.806 721.385 366.17C724.519 368.479 724.299 373.208 722.099 376.177C719.9 379.146 713.247 380.906 708.354 377.717C705.055 375.627 706.539 369.414 710.223 366.555Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.299 376.837C710.443 375.077 714.182 374.692 716.381 376.342C718.581 377.991 718.361 381.455 716.711 383.71C715.062 385.964 709.288 386.734 707.034 385.084C704.835 383.435 705.55 379.036 708.299 376.837Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.653 379.806C709.508 384.26 704.615 386.349 701.921 385.029C699.226 383.71 699.611 379.476 701.811 375.022C703.955 370.569 707.254 369.359 710.003 370.679C712.697 372.053 713.852 375.352 711.653 379.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.917 382.335C712.422 383.38 710.718 384.205 710.003 383.82C709.233 383.435 709.453 382.5 709.948 381.51C710.443 380.466 711.543 379.806 712.258 380.136C713.082 380.521 713.412 381.29 712.917 382.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.687 377.277C713.687 377.277 714.127 373.978 712.422 371.833C710.663 369.744 706.319 367.82 703.46 371.284C703.46 371.284 701.645 373.978 705.054 375.847C708.463 377.717 708.573 375.572 709.618 378.046C710.663 380.521 712.752 379.806 712.917 380.356L713.687 377.277Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.295 441.552C707.199 441.717 710.278 440.398 713.632 438.418C716.216 436.934 719.515 436.274 722.209 435.229C724.354 423.133 721.879 403.339 717.261 395.531C713.192 388.658 713.192 389.758 711.653 389.098C709.563 388.163 707.144 388.438 705.439 389.978C705.384 390.033 705.384 390.033 705.329 390.088C703.405 391.902 703.24 395.916 702.91 400.095C702.58 404.274 700.986 403.504 704.56 410.817C706.154 414.006 703.24 435.339 703.295 441.552Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.113 380.466L704.945 380.851C705 381.565 705.604 388.328 706.319 390.748C706.649 391.462 707.969 391.627 709.288 391.023C710.498 390.528 711.268 389.593 711.158 388.878C710.718 387.449 710.278 382.94 710.113 380.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.34 463.381C705.646 463.381 706.704 462.322 706.704 461.016C706.704 459.71 705.646 458.652 704.34 458.652C703.034 458.652 701.976 459.71 701.976 461.016C701.976 462.322 703.034 463.381 704.34 463.381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.67 446.171C704.67 447.49 703.625 448.535 702.305 448.535C701.811 448.535 701.371 448.37 700.986 448.15C701.646 446.721 702.36 445.291 703.185 443.916C704.01 444.301 704.67 445.181 704.67 446.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.44 443.971C721.275 445.236 721 446.611 720.725 448.15C720.67 448.315 720.67 448.425 720.615 448.59C719.295 448.59 718.251 447.545 718.251 446.226C718.251 444.906 719.295 443.861 720.615 443.861C720.89 443.806 721.165 443.861 721.44 443.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.739 488.398C710.044 488.398 711.103 487.339 711.103 486.034C711.103 484.728 710.044 483.669 708.739 483.669C707.433 483.669 706.374 484.728 706.374 486.034C706.374 487.339 707.433 488.398 708.739 488.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.78 468.604C720.34 469.264 719.625 469.649 718.801 469.649C717.481 469.649 716.436 468.604 716.436 467.284C716.436 465.965 717.481 464.92 718.801 464.92C719.13 464.92 719.46 464.975 719.735 465.085C719.955 466.295 720.34 467.449 720.78 468.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.842 473.772C698.842 474.377 698.622 474.927 698.237 475.367C697.797 475.862 697.192 476.192 696.477 476.192C696.422 476.192 696.312 476.192 696.202 476.192C696.257 474.542 696.312 472.948 696.422 471.463H696.477C697.467 471.463 698.237 472.013 698.622 472.838C698.787 473.113 698.842 473.442 698.842 473.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.175 483.703L776 473.708L761.049 439.792L738.239 448.335L749.175 483.703Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.351 445.516L753.531 437.913C752.421 434.923 749.089 433.385 746.099 434.496C743.109 435.606 741.571 438.938 742.682 441.928L745.501 449.531",
    stroke: "#7DE3F4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.843 427.405C745.843 427.405 744.561 435.948 746.014 437.571C747.466 439.194 749.687 431.164 747.637 426.38L745.843 427.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.245 429.455C746.611 429.455 747.807 429.54 749.345 429.626C747.637 402.459 740.717 398.358 715.344 393.062C711.499 392.293 709.876 398.956 716.54 399.64C739.777 402.117 740.973 406.047 745.245 429.455Z",
    fill: "#A6EEFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 628,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide4);
export default __webpack_public_path__ + "static/media/slide4.490d24afb9dab0bf80c8ddfa7bd39bb5.svg";
export { ForwardRef as ReactComponent };